const styles = {
  message: {
    fontSize: 'var(--fs-16, 1rem)',
  },
  button: {
    fontSize: 'var(--fs-16, 1rem)',
  },
  container: {
    borderRadius: '10px',
    margin: '10 10 10 10',
    paddingTop: '15px',
    paddingLeft: '25px',
    paddingRight: '30px',
  },
  title: {
    fontSize: 'var(--fs-18, 1.125rem)',
    fontWeight: '400',
  },
}

export default styles
